import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Kfi } from '../../form-application/kfi';
import { ApplicationFormStore } from '../../form-application/shared/services/application-form-store';
import { ValidationErrors } from '../../lib/models/validation/validation-errors';

@Injectable()
export class AdvisedIllustrationStore extends ApplicationFormStore {
  public kfiData: Kfi;
  private validationErrorsSubject$ = new Subject();

  constructor() {
    super();
    this.isSubmitted = true;
    this.dataObservable = this.validationErrorsSubject$.asObservable();
  }

  set formErrors(validationErrors: ValidationErrors) {
    this.validationErrors = validationErrors;
    this.validationErrorsSubject$.next();
  }
}
